import { useUserProfileContext } from "@context/user_profile";
import { getCookie, removeCookie, setCookie } from "@util/cookie";
import { LogOutIcon, ToggleLeftIcon, ToggleRightIcon } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

export function Header() {
    const isAccountStartupScreening: boolean = Boolean(getCookie("__account_startup_screening__"));
    const [isLoadingUserInfo, currentUserInfo] = useUserProfileContext();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <>
            <div className="display sm:hidden sticky border-gray-200 bg-white top-0 left-0 right-0 z-10">
                <div className="flex flex-row justify-between items-center border-b p-4 w-full">
                    <div>
                        <Link to="/dashboard">
                            <img width="32" src={`${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/ourteam_logo_only.png`} alt="ourteam" />
                        </Link>
                    </div>
                    {(!isLoadingUserInfo && currentUserInfo) && (
                        <div className="relative">
                            <div className="flex flex-row items-center justify-center space-x-4">
                                {currentUserInfo && currentUserInfo?.role === "hr" && currentUserInfo?.company_id === import.meta.env.VITE_FIRSTMOVE_COMPANY_ID && (
                                    <button
                                        className="text-center w-full items-center justify-center flex flex-row flex-1"
                                        onClick={() => {
                                            if (!isAccountStartupScreening) {
                                                setCookie("__account_startup_screening__", "true");
                                            } else {
                                                removeCookie("__account_startup_screening__");
                                            }
                                            // window reload
                                            window.location.reload();
                                        }}
                                    >
                                        {isAccountStartupScreening ? (
                                            <ToggleRightIcon className="w-7 h-7 text-gray-500" />
                                        ) : (
                                            <ToggleLeftIcon className="w-7 h-7 text-gray-500" />
                                        )}
                                    </button>
                                )}
                                <div className="h-8 w-8 rounded-full overflow-hidden cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
                                    <img
                                        src={`${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/${currentUserInfo?.profile_picture_path || ""}`}
                                        onError={(e) => {
                                            e.currentTarget.src = `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/default_avatar.png`;
                                        }}
                                    />
                                </div>
                            </div>
                            {isOpen && (
                                <div className="absolute right-0 w-64 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 py-2 z-50 transition-all duration-200 ease-in-out">
                                    <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            Signed in as
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-gray-100 truncate">
                                            {currentUserInfo.email}
                                        </p>
                                    </div>
                                    <div className="py-1">
                                        <button
                                            className="w-full flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                                            onClick={() => {
                                                setIsOpen(false);
                                                removeCookie("authToken");
                                                removeCookie("__account_startup_screening__");
                                                sessionStorage.removeItem("cv_uuid");
                                                removeCookie("__apply_job_guest__")
                                                window.location.href = "/";
                                            }}
                                        >
                                            <LogOutIcon size={16} className="mr-2" />
                                            Sign out
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
